import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconAutoTopUpProps } from './IconAutoTopUp.types'
import * as Styled from './styles/IconAutoTopUp.style'

import { nonThemeableRules } from '../../ruleSet'

const IconAutoTopUp: FC<IconAutoTopUpProps> = ({
  size = nonThemeableRules.defaultSize as number as IconAutoTopUpProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconAutoTopUpProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M10.46 19.531h3m-3-2.562c0-.864-2.015-1.563-4.5-1.563-2.483 0-4.5.7-4.5 1.563s2.017 1.562 4.5 1.562c2.485 0 4.5-.699 4.5-1.562Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M10.46 16.969v2.949c-.589.691-2.374 1.05-4.5 1.05-2.124 0-3.913-.5-4.5-1.187v-2.875' vectorEffect='non-scaling-stroke' />
          <path
            d='M2.46 20.41v2c.587.688 2.376 1.125 4.5 1.125 2.126 0 3.911-.312 4.5-1v-2.5s0-.5-1-.5m7.04-7.504v7.305a2.164 2.164 0 0 1-2.164 2.164h-3.719M6.5 15.309V4.664C6.5 3.47 7.469 2.5 8.664 2.5H17.5v3.531'
            vectorEffect='non-scaling-stroke'
          />
          <path d='m20.527 5.89-7.703 7.633-2.945-2.945' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconAutoTopUp
